import { DoorSizeText, LockerDimensionsInterface } from './interfaces'

export const LockerXS: LockerDimensionsInterface = {
    id: DoorSizeText.ExtraSmall,
    sizeNumber: 8,
    height: 85,
    width: 140,
    length: 520,
}
export const LockerS: LockerDimensionsInterface = {
    id: DoorSizeText.Small,
    height: 55,
    sizeNumber: 4,
    width: 320,
    length: 520,
}
export const LockerM: LockerDimensionsInterface = {
    id: DoorSizeText.Medium,
    sizeNumber: 5,
    height: 140,
    width: 320,
    length: 520,
}
export const LockerL: LockerDimensionsInterface = {
    id: DoorSizeText.Large,
    sizeNumber: 6,
    height: 310,
    width: 320,
    length: 520,
}
export const LockerXL: LockerDimensionsInterface = {
    id: DoorSizeText.ExtraLarge,
    sizeNumber: 7,
    height: 680,
    width: 320,
    length: 520,
}

export const LockerDimensionsList = [
    LockerXS,
    LockerS,
    LockerM,
    LockerL,
    LockerXL,
]

const CarrefourEscobar = {
    id: 10,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const Open25 = {
    id: 12,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const CarrefourLaPlata = {
    id: 13,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const CarrefourBernal = {
    id: 14,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const CarrefourQuilmes = {
    id: 15,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const EstacionBarrioPanamericano = {
    id: 91,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const AxiosCipolletti = {
    id: 118,
    name: 'Mateo Gelves 530 - B1625 - Belén de Escobar',
    locationDetails: '',
    latitude: '-34,34411082',
    longitude: '-58,78975934',
    locationAddress: 'Mateo Gelves 530',
    city: 'AMBA',
    country: 'Argentina',
    province: 'Buenos Aires',
    zipCode: 'B1625',
}

const LockersList = [
    CarrefourEscobar,
    Open25,
    CarrefourLaPlata,
    CarrefourBernal,
    CarrefourQuilmes,
    EstacionBarrioPanamericano,
    AxiosCipolletti,
]

export {
    CarrefourEscobar,
    CarrefourLaPlata,
    Open25,
    AxiosCipolletti,
    EstacionBarrioPanamericano,
    CarrefourQuilmes,
    CarrefourBernal,
    LockersList,
}
